var _rect, _rect2, _rect3, _rect4, _path, _circle, _circle2, _path2, _use, _use2, _use3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#3A75C4",
    width: 500,
    height: 300
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CE1126",
    width: 500,
    height: 225
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 500,
    height: 150
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFC61E",
    width: 500,
    height: 75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D8E33",
    d: "M0,300l250-150L0,0V300z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 85,
    cy: 150,
    r: 67.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#3D8E33",
    cx: 115,
    cy: 150,
    r: 67.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "star",
    fill: "#FFF",
    d: "M100.0104,89.1996l7.3594,22.5883L88.1125,97.8394h23.775l-19.2573,13.9486L100.0104,89.1996z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    y: 32.2083
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    y: 64.4166
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    y: 96.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.18fb13911403c5195cc696c4abd5a4a0.svg";
export { ForwardRef as ReactComponent };